import * as ngCore from '@angular/core'

/**
 * @deprecated
 * Page in Quiver used to manage deployment of resources
 */
@ngCore.Component({
  selector: 'atn-quiver-deployment-center-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
